document.addEventListener('DOMContentLoaded', function() {
  const productDataElement = document.getElementById('product-data');
  let productData = [];
  
  if (productDataElement) {
    try {
      const jsonText = productDataElement.textContent.trim();
      if (jsonText && jsonText !== '[]' && jsonText !== '') {
        productData = JSON.parse(jsonText);
      }
    } catch (error) {
      console.warn('Could not parse product data:', error);
      productData = [];
    }
  }
  
  // No sample products - only use real Shopify data
  if (!productData || productData.length === 0) {
    console.warn('No product data available from Shopify');
  }
  
  let userAnswers = {};
  let currentQuestionIndex = 0;
  const questions = document.querySelectorAll('.question-group');
  let questionOrder = [];
  let totalQuestions = questions.length;

  if (totalQuestions === 0) {
    console.error('No questions found. Check HTML structure.');
    return;
  }

  function parseCommaSeparatedValue(value) {
    if (!value) return [];
    
    // Handle arrays from Liquid (your current setup)
    if (Array.isArray(value)) {
      return value.map(function(item) {
        return String(item).trim().toLowerCase();
      });
    }
    
    // Handle strings (comma-separated or single values)
    if (typeof value === 'string') {
      return value.split(',').map(function(item) {
        return item.trim().toLowerCase();
      });
    }
    
    return [];
  }

  function initQuiz() {
    setupQuestionOrder();
    setupOptionButtons();
    setupSliders();
    setupNavigation();
    setupFormSubmission();
    showCurrentQuestion();
    updateProgress();
  }

  function setupQuestionOrder() {
    questionOrder = ['vehicle-type', 'power-type', 'experience'];
    
    // Check what questions actually exist in the HTML
    const heightQuestion = document.querySelector('[data-question="height"]');
    const ageQuestion = document.querySelector('[data-question="age"]');
    
    if (heightQuestion) {
      questionOrder.push('height');
    }
    if (ageQuestion) {
      questionOrder.push('age');
    }
    
    totalQuestions = questionOrder.length;
    console.log('Final question order:', questionOrder);
  }

  function updateQuestionOrder() {
    // No longer need to update question order based on experience level
    // All questions are determined at setup
    console.log('Question order remains:', questionOrder);
  }

  function showCurrentQuestion() {
    questions.forEach(function(question) {
      question.classList.remove('active');
    });
    
    if (currentQuestionIndex < questionOrder.length) {
      const currentQuestionType = questionOrder[currentQuestionIndex];
      const currentQuestionElement = document.querySelector('[data-question="' + currentQuestionType + '"]');
      if (currentQuestionElement) {
        currentQuestionElement.classList.add('active');
      }
    }
  }

  function setupOptionButtons() {
    const buttons = document.querySelectorAll('.option-button');
    
    buttons.forEach(function(button) {
      button.addEventListener('click', function(e) {
        e.preventDefault();
        
        const questionGroup = this.closest('.question-group');
        if (!questionGroup) return;
        
        const questionType = questionGroup.dataset.question;
        
        questionGroup.querySelectorAll('.option-button').forEach(function(btn) {
          btn.classList.remove('selected');
        });
        
        this.classList.add('selected');
        userAnswers[questionType] = this.dataset.value;
        
        updateNavigationButtons();
        
        setTimeout(function() {
          if (currentQuestionIndex < questionOrder.length - 1) {
            nextQuestion();
          }
        }, 800);
      });
    });
  }

  function setupSliders() {
    const heightSlider = document.getElementById('heightSlider');
    const weightSlider = document.getElementById('weightSlider');
    const heightValue = document.getElementById('heightValue');
    const weightValue = document.getElementById('weightValue');

    if (heightSlider && heightValue) {
      heightSlider.addEventListener('input', function() {
        const cm = this.value;
        const feet = Math.floor(cm / 30.48);
        const inches = Math.round((cm / 30.48 - feet) * 12);
        heightValue.textContent = cm + ' cm (' + feet + "'" + inches + '")';
        userAnswers.height = parseInt(cm);
        updateNavigationButtons();
      });
      
      // Set initial value
      userAnswers.height = parseInt(heightSlider.value) || 175;
      const initialCm = userAnswers.height;
      const initialFeet = Math.floor(initialCm / 30.48);
      const initialInches = Math.round((initialCm / 30.48 - initialFeet) * 12);
      heightValue.textContent = initialCm + ' cm (' + initialFeet + "'" + initialInches + '")';
    }

    if (weightSlider && weightValue) {
      weightSlider.addEventListener('input', function() {
        const kg = this.value;
        const lbs = Math.round(kg * 2.20462);
        weightValue.textContent = kg + ' kg (' + lbs + ' lbs)';
        userAnswers.weight = parseInt(kg);
        updateNavigationButtons();
      });
      
      // Set initial value
      userAnswers.weight = parseInt(weightSlider.value) || 75;
      const initialKg = userAnswers.weight;
      const initialLbs = Math.round(initialKg * 2.20462);
      weightValue.textContent = initialKg + ' kg (' + initialLbs + ' lbs)';
    }

    // Always set default values even if sliders don't exist
    if (!userAnswers.height) userAnswers.height = 175;
    if (!userAnswers.weight) userAnswers.weight = 75;
  }

  function setupNavigation() {
    const prevButton = document.getElementById('prevButton');
    const nextButton = document.getElementById('nextButton');
    
    if (prevButton) {
      prevButton.addEventListener('click', function(e) {
        e.preventDefault();
        prevQuestion();
      });
    }
    
    if (nextButton) {
      nextButton.addEventListener('click', function(e) {
        e.preventDefault();
        nextQuestion();
      });
    }
  }

  function setupFormSubmission() {
    const form = document.getElementById('bikeFinderForm');
    if (form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        findProducts();
      });
    }
  }

  function nextQuestion() {
    if (currentQuestionIndex < questionOrder.length - 1) {
      currentQuestionIndex++;
      showCurrentQuestion();
      updateProgress();
      updateNavigationButtons();
    }
  }

  function prevQuestion() {
    if (currentQuestionIndex > 0) {
      currentQuestionIndex--;
      showCurrentQuestion();
      updateProgress();
      updateNavigationButtons();
    }
  }

  function updateProgress() {
    const progressFill = document.getElementById('progressFill');
    if (progressFill) {
      const progress = ((currentQuestionIndex + 1) / questionOrder.length) * 100;
      progressFill.style.width = progress + '%';
    }
  }

  function updateNavigationButtons() {
    const prevBtn = document.getElementById('prevButton');
    const nextBtn = document.getElementById('nextButton');
    const findBtn = document.getElementById('findButton');
    
    if (!prevBtn || !nextBtn || !findBtn) return;
    
    prevBtn.disabled = currentQuestionIndex === 0;
    
    const currentQuestionType = questionOrder[currentQuestionIndex];
    let isAnswered = userAnswers.hasOwnProperty(currentQuestionType);
    
    // For height and weight questions, they're automatically answered by sliders
    if (currentQuestionType === 'height' || currentQuestionType === 'weight') {
      isAnswered = true;
    }
    
    if (currentQuestionIndex === questionOrder.length - 1) {
      nextBtn.style.display = 'none';
      findBtn.style.display = 'block';
    } else {
      nextBtn.style.display = 'block';
      findBtn.style.display = 'none';
      nextBtn.disabled = !isAnswered;
    }
  }

  function findProducts() {
    const resultsSection = document.getElementById('resultsSection');
    const loadingDiv = document.getElementById('loadingDiv');
    const productGrid = document.getElementById('productGrid');
    
    if (!resultsSection || !loadingDiv || !productGrid) return;
    
    resultsSection.classList.add('show');
    loadingDiv.style.display = 'block';
    productGrid.style.display = 'none';
    
    resultsSection.scrollIntoView({ behavior: 'smooth' });

    setTimeout(function() {
      const matches = calculateMatches();
      displayResults(matches);
    }, 2000);
  }

  function calculateMatches() {
    const matches = [];
    const alternatives = [];
    
    console.log('User answers:', userAnswers);
    console.log('Product data:', productData);
    
    // If no product data available, return empty
    if (!productData || productData.length === 0) {
      console.warn('No product data available for matching');
      return [];
    }
    
    productData.forEach(function(product) {
      let score = 0;
      let maxScore = 0;
      let isStrictMatch = true;
      let matchDetails = [];
      
      // Vehicle type matching (40 points) - STRICT unless no preference
      maxScore += 40;
      if (userAnswers['vehicle-type']) {
        const userVehicleType = userAnswers['vehicle-type'].toLowerCase();
        const productVehicleType = product.vehicle_type ? product.vehicle_type.toLowerCase() : '';
        
        console.log('Checking vehicle type for product:', product.title);
        console.log('User vehicle type:', userVehicleType);
        console.log('Product vehicle type:', productVehicleType);
        
        if (userVehicleType === 'no-preference') {
          score += 40;
          matchDetails.push('Vehicle type: No preference (40pts)');
        } else if (userVehicleType === 'both' || userVehicleType === 'any') {
          score += 40;
          matchDetails.push('Vehicle type: Any (40pts)');
        } else if (userVehicleType === productVehicleType) {
          score += 40;
          matchDetails.push('Vehicle type: Exact match (40pts)');
        } else {
          // STRICT - wrong vehicle type excludes the product
          score += 0;
          isStrictMatch = false;
          matchDetails.push('Vehicle type: Mismatch, user wants ' + userVehicleType + ' but product is ' + productVehicleType + ' (0pts)');
        }
      } else {
        score += 40;
        matchDetails.push('Vehicle type: Not specified (40pts)');
      }
      
      // Age suitability matching (20 points) - FLEXIBLE/PASSIVE
      maxScore += 20;
      if (userAnswers.age) {
        const userAge = userAnswers.age.toLowerCase();
        const productAges = parseCommaSeparatedValue(product.age_suitability);
        
        console.log('Checking age for product:', product.title);
        console.log('User age:', userAge);
        console.log('Product age_suitability raw:', product.age_suitability);
        console.log('Product ages parsed:', productAges);
        
        if (productAges.indexOf(userAge) !== -1) {
          score += 20;
          matchDetails.push('Age: Perfect match (20pts)');
        } else {
          // FLEXIBLE age matching - don't exclude, just score lower
          if (userAge === 'child') {
            if (productAges.indexOf('teen') !== -1 || productAges.indexOf('adult') !== -1) {
              score += 10;
              matchDetails.push('Age: Child can grow into this model (10pts)');
            } else {
              score += 15;
              matchDetails.push('Age: Age not specified, likely suitable (15pts)');
            }
          } else if (userAge === 'teen') {
            if (productAges.indexOf('child') !== -1 || productAges.indexOf('adult') !== -1) {
              score += 15;
              matchDetails.push('Age: Compatible age range (15pts)');
            } else {
              score += 15;
              matchDetails.push('Age: Age not specified, likely suitable (15pts)');
            }
          } else if (userAge === 'adult') {
            if (productAges.indexOf('child') !== -1 || productAges.indexOf('teen') !== -1) {
              score += 12;
              matchDetails.push('Age: Adult can use smaller models (12pts)');
            } else {
              score += 15;
              matchDetails.push('Age: Age not specified, likely suitable (15pts)');
            }
          } else {
            score += 15;
            matchDetails.push('Age: Age compatibility assumed (15pts)');
          }
        }
      } else {
        score += 18;
        matchDetails.push('Age: Not specified (18pts)');
      }
      
      // Experience level matching (20 points) - FLEXIBLE/PASSIVE
      maxScore += 20;
      if (userAnswers.experience) {
        const userExp = userAnswers.experience.toLowerCase();
        const productExp = parseCommaSeparatedValue(product.experience_level);
        
        console.log('Checking experience for product:', product.title);
        console.log('User experience:', userExp);
        console.log('Product experience_level raw:', product.experience_level);
        console.log('Product experience parsed:', productExp);
        
        if (productExp.indexOf(userExp) !== -1) {
          score += 20;
          matchDetails.push('Experience: Perfect match (20pts)');
        } else {
          // FLEXIBLE experience matching - don't exclude, just score differently
          if (userExp === 'beginner') {
            if (productExp.indexOf('intermediate') !== -1) {
              score += 15;
              matchDetails.push('Experience: Good for progression (15pts)');
            } else if (productExp.indexOf('advanced') !== -1) {
              score += 10;
              matchDetails.push('Experience: Advanced option for growth (10pts)');
            } else {
              score += 17;
              matchDetails.push('Experience: Suitable for beginners (17pts)');
            }
          } else if (userExp === 'intermediate') {
            if (productExp.indexOf('beginner') !== -1 || productExp.indexOf('advanced') !== -1) {
              score += 18;
              matchDetails.push('Experience: Compatible skill level (18pts)');
            } else {
              score += 17;
              matchDetails.push('Experience: Suitable for intermediate (17pts)');
            }
          } else if (userExp === 'advanced') {
            if (productExp.indexOf('intermediate') !== -1) {
              score += 18;
              matchDetails.push('Experience: Advanced can handle intermediate (18pts)');
            } else if (productExp.indexOf('beginner') !== -1) {
              score += 15;
              matchDetails.push('Experience: Advanced can use any level (15pts)');
            } else {
              score += 17;
              matchDetails.push('Experience: Suitable for advanced (17pts)');
            }
          } else {
            score += 16;
            matchDetails.push('Experience: Experience level assumed suitable (16pts)');
          }
        }
      } else {
        score += 18;
        matchDetails.push('Experience: Not specified (18pts)');
      }
      
      // Power type matching (10 points) - STRICT unless no preference
      maxScore += 10;
      if (userAnswers['power-type']) {
        const userPowerType = userAnswers['power-type'].toLowerCase();
        const productPowerType = product.power_type ? product.power_type.toLowerCase() : '';
        
        console.log('Checking power type for product:', product.title);
        console.log('User power type:', userPowerType);
        console.log('Product power type:', productPowerType);
        
        if (userPowerType === 'no-preference') {
          score += 10;
          matchDetails.push('Power type: No preference (10pts)');
        } else if (userPowerType === 'any') {
          score += 10;
          matchDetails.push('Power type: Any (10pts)');
        } else if (userPowerType === productPowerType) {
          score += 10;
          matchDetails.push('Power type: ' + product.power_type + ' (10pts)');
        } else {
          // STRICT - wrong power type excludes the product
          score += 0;
          isStrictMatch = false;
          matchDetails.push('Power type: Mismatch, user wants ' + userPowerType + ' but product is ' + productPowerType + ' (0pts)');
        }
      } else {
        score += 10;
        matchDetails.push('Power type: Not specified (10pts)');
      }
      
      // Height range matching (STRICT SAFETY - MUST EXCLUDE if outside range)
      if (userAnswers.height) {
        const userHeight = parseInt(userAnswers.height);
        
        console.log('Checking height for product:', product.title);
        console.log('User height:', userHeight + 'cm');
        console.log('Product height_range_min:', product.height_range_min);
        console.log('Product height_range_max:', product.height_range_max);
        
        if (product.height_range_min && product.height_range_max) {
          maxScore += 5;
          const minHeight = parseInt(product.height_range_min);
          const maxHeight = parseInt(product.height_range_max);
          
          if (userHeight >= minHeight && userHeight <= maxHeight) {
            score += 5;
            matchDetails.push('Height: Perfect fit (' + userHeight + 'cm fits ' + minHeight + '-' + maxHeight + 'cm range) (5pts)');
          } else {
            // Height is outside range - STRICT EXCLUSION
            console.log('EXCLUDING product due to height: ' + userHeight + 'cm outside ' + minHeight + '-' + maxHeight + 'cm range');
            score += 0;
            isStrictMatch = false;
            matchDetails.push('Height: EXCLUDED - ' + userHeight + 'cm outside safe range ' + minHeight + '-' + maxHeight + 'cm (0pts)');
          }
        } else {
          // If no height range specified, assume it's suitable (give partial points)
          maxScore += 5;
          score += 3;
          matchDetails.push('Height: Range not specified, assuming suitable (3pts)');
        }
      }
      
      // Weight capacity matching (STRICT SAFETY - MUST EXCLUDE if over capacity)
      if (userAnswers.weight) {
        const userWeight = parseInt(userAnswers.weight);
        
        console.log('Checking weight for product:', product.title);
        console.log('User weight:', userWeight + 'kg');
        console.log('Product weight_capacity:', product.weight_capacity);
        
        if (product.weight_capacity) {
          maxScore += 3;
          const weightCapacity = parseInt(product.weight_capacity);
          
          if (userWeight <= weightCapacity) {
            score += 3;
            matchDetails.push('Weight: Within capacity (' + userWeight + 'kg ≤ ' + weightCapacity + 'kg) (3pts)');
          } else {
            // Weight exceeds capacity - STRICT EXCLUSION
            console.log('EXCLUDING product due to weight: ' + userWeight + 'kg exceeds ' + weightCapacity + 'kg capacity');
            score += 0;
            isStrictMatch = false;
            matchDetails.push('Weight: EXCLUDED - ' + userWeight + 'kg exceeds ' + weightCapacity + 'kg capacity (0pts)');
          }
        } else {
          // If no weight capacity specified, assume it's suitable for adults
          maxScore += 3;
          score += 2;
          matchDetails.push('Weight: Capacity not specified, assuming suitable (2pts)');
        }
      }
      
      const matchPercentage = maxScore > 0 ? Math.round((score / maxScore) * 100) : 0;
      
      console.log('Product: ' + product.title);
      console.log('Score: ' + score + '/' + maxScore + ' = ' + matchPercentage + '%');
      console.log('Strict match: ' + isStrictMatch);
      console.log('Match details: ', matchDetails);
      
      // Lower the strict match threshold even more to be inclusive
      if (isStrictMatch && matchPercentage >= 30) { // Lowered from 40% to 30%
        matches.push({
          product: product,
          score: matchPercentage,
          isAlternative: false
        });
      } else if (matchPercentage >= 15) { // Lowered from 20% to 15%
        alternatives.push({
          product: product,
          score: matchPercentage,
          isAlternative: true
        });
      }
    });
    
    console.log('Strict matches found: ' + matches.length);
    console.log('Alternative matches found: ' + alternatives.length);
    
    matches.sort(function(a, b) { return b.score - a.score; });
    alternatives.sort(function(a, b) { return b.score - a.score; });
    
    if (matches.length === 0 && alternatives.length > 0) {
      return alternatives.slice(0, 3);
    }
    
    return matches;
  }

  function displayResults(matches) {
    const loadingDiv = document.getElementById('loadingDiv');
    const resultsCount = document.getElementById('resultsCount');
    const productGrid = document.getElementById('productGrid');
    
    if (!loadingDiv || !resultsCount || !productGrid) return;
    
    loadingDiv.style.display = 'none';
    
    if (matches.length === 0) {
      resultsCount.innerHTML = 
        '<div style="color: #f59e0b; margin-bottom: 12px; font-size: 18px; font-weight: 600;">No exact matches found for your criteria</div>' +
        '<div style="color: #6b7280; font-size: 14px; margin-bottom: 16px;">We don\'t currently have products that match your specific requirements.</div>' +
        '<div style="color: #374151; font-size: 14px;">Please browse our full collection or contact us for personalized recommendations.</div>';
      
      productGrid.innerHTML = 
        '<div style="grid-column: 1 / -1; text-align: center; padding: 40px 20px; background: #f8fafc; border: 1px solid #e1e5e9; border-radius: 8px;">' +
          '<div style="color: #6b7280; font-size: 16px; margin-bottom: 20px;">Browse our full product range:</div>' +
          '<a href="/collections/all" style="background: #c4301c; color: white; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: 600; display: inline-block; margin-right: 12px;">View All Products</a>' +
          '<a href="/pages/contact" style="background: #ffffff; color: #c4301c; padding: 12px 24px; text-decoration: none; border-radius: 6px; font-weight: 600; display: inline-block; border: 1px solid #c4301c;">Contact Us</a>' +
        '</div>';
      return;
    }
    
    const hasAlternatives = matches.some(function(match) { return match.isAlternative; });
    
    if (hasAlternatives) {
      resultsCount.innerHTML = 
        '<div style="color: #f59e0b; margin-bottom: 8px; font-size: 18px; font-weight: 600;">⚠️ No exact matches found</div>' +
        '<div style="color: #6b7280; font-size: 14px;">Here are some alternatives from our collection that might interest you:</div>';
    } else {
      resultsCount.textContent = 'Found ' + matches.length + ' perfect match' + (matches.length > 1 ? 'es' : '') + ' for you!';
    }
    
    productGrid.innerHTML = matches.map(function(match) {
      // Handle product specs properly - comprehensive checking
      let specs = 'Specifications available on product page';
      
      console.log('Product specs debug for:', match.product.title);
      console.log('product_specs:', match.product.product_specs, typeof match.product.product_specs);
      console.log('specs:', match.product.specs, typeof match.product.specs);
      
      // Check product_specs first
      if (match.product.product_specs) {
        if (typeof match.product.product_specs === 'string' && match.product.product_specs.trim() !== '') {
          specs = match.product.product_specs;
        } else if (Array.isArray(match.product.product_specs) && match.product.product_specs.length > 0) {
          specs = match.product.product_specs.join(', ');
        }
      }
      // Fallback to specs field
      else if (match.product.specs) {
        if (typeof match.product.specs === 'string' && match.product.specs.trim() !== '') {
          specs = match.product.specs;
        } else if (Array.isArray(match.product.specs) && match.product.specs.length > 0) {
          specs = match.product.specs.join(', ');
        }
      }
      // Final fallback to description if available
      else if (match.product.description && typeof match.product.description === 'string') {
        specs = match.product.description.substring(0, 100) + '...';
      }
      
      console.log('Final specs used:', specs);
      
      return '<div class="product-card ' + (match.isAlternative ? 'alternative-match' : '') + '">' +
        '<div class="match-score ' + (match.isAlternative ? 'alternative-score' : '') + '">' + match.score + '% ' + (match.isAlternative ? 'Alt' : 'Match') + '</div>' +
        '<div class="product-image">' +
          (match.product.featured_image ? 
            '<img src="' + match.product.featured_image + '" alt="' + match.product.title + '" loading="lazy">' : 
            '<div class="product-image-placeholder">Product Image</div>') +
        '</div>' +
        '<div class="product-info">' +
          '<div class="product-title">' + match.product.title + '</div>' +
          '<div class="product-price">' + match.product.price + '</div>' +
          '<div class="product-specs">' + specs + '</div>' +
          '<a href="' + match.product.url + '" class="view-product-btn">View Product</a>' +
        '</div>' +
      '</div>';
    }).join('');
    productGrid.style.display = 'grid';
  }

  window.resetQuiz = function() {
    userAnswers = {};
    currentQuestionIndex = 0;
    
    setupQuestionOrder();
    
    questions.forEach(function(question) {
      question.classList.remove('active');
      question.querySelectorAll('.option-button').forEach(function(btn) {
        btn.classList.remove('selected');
      });
    });
    
    showCurrentQuestion();
    
    const heightSlider = document.getElementById('heightSlider');
    const weightSlider = document.getElementById('weightSlider');
    const heightValue = document.getElementById('heightValue');
    const weightValue = document.getElementById('weightValue');
    
    if (heightSlider && weightSlider && heightValue && weightValue) {
      heightSlider.value = 175;
      weightSlider.value = 75;
      heightValue.textContent = '175 cm (5\'9")';
      weightValue.textContent = '75 kg (165 lbs)';
    }
    
    userAnswers.height = 175;
    userAnswers.weight = 75;
    
    const resultsSection = document.getElementById('resultsSection');
    if (resultsSection) {
      resultsSection.classList.remove('show');
    }
    
    updateProgress();
    updateNavigationButtons();
    
    const bikeFinder = document.querySelector('.bike-finder');
    if (bikeFinder) {
      bikeFinder.scrollIntoView({ behavior: 'smooth' });
    }
  };

  initQuiz();
});